export function areSomeFilesEmpty(files) {
  return files.some((file) => !file.size);
}
